import React from "react";



const ListaBlog = ({ itens }) => {
    return (
        <section
            style={{
                width: "100%",
                padding: "10px",
                fontFamily: "'Inter', sans-serif",
                marginBottom: "40px",
            }}
        >
            <div
                style={{
                    maxWidth: "800px",
                    margin: "0 auto",
                }}
            >
                <ul
                    style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    {itens.map((item, index) => (
                        <li
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "18px",
                                color: "#111",
                                fontSize: "18px",
                                lineHeight: 1.7,
                                fontWeight: 400,
                            }}
                        >
                            <span
                                style={{
                                    width: "9px",
                                    height: "9px",
                                    borderRadius: "50%",
                                    background: "#1EFF86",
                                    marginTop: "12px",
                                    flexShrink: 0,

                                }}
                            />

                            <span style={{ textAlign: "justify" }}>{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default ListaBlog;